import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AppTitleService } from './shared/services/app-title.service';
import { SlugTenantGuard } from './shared/guards/slug-tenant.guard';
import { autoTenantRedirectGuard } from './shared/guards/auto-tenant-redirect.guard';
import { RootCanActivateService } from './shared/services/root-can-activate.service';

export const appRoutes: Routes = [
  // Subdomain-based routes (existing)
  {
    path: 'production',
    title: AppTitleService,
    loadComponent: () => import('./production/production.component'),
    data: { depthX: 0 },
  },
  {
    path: 'production/:id',
    title: AppTitleService,
    loadComponent: () => import('./production/production.component'),
    data: { depthX: 0 },
  },
  {
    path: 'reservation/:reservationId',
    title: AppTitleService,
    loadComponent: () => import('./reservation/reservation.component'),
    data: { depthX: 1 },
  },
  {
    path: 'admin',
    title: AppTitleService,
    canActivate: [autoTenantRedirectGuard],
    loadChildren: () => import('./admin/admin.routes'),
    data: { depthX: 1, titlePrefix: 'Administratie' },
  },
  {
    path: 'public',
    title: 'Reservatie App',
    loadComponent: () => import('./public/public.component'),
  },
  {
    path: 'blog',
    title: 'Blog – Reservatie App',
    loadComponent: () => import('./blog/blog-list.component'),
  },
  {
    path: 'blog/:slug',
    title: 'Blog – Reservatie App',
    loadComponent: () => import('./blog/blog-post.component'),
  },
  {
    path: 'signup',
    title: 'Registreer – Reservatie App',
    loadComponent: () => import('./signup/signup.component'),
  },
  {
    path: 'kosten-berekenen',
    title: 'Kosten berekenen – Reservatie App',
    loadComponent: () =>
      import('./public/cost-calculator/cost-calculator.component'),
  },
  {
    path: 'help',
    title: 'Help – Reservatie App',
    loadComponent: () => import('./help/help-list.component'),
  },
  {
    path: 'help/:slug',
    title: 'Help – Reservatie App',
    loadComponent: () => import('./help/help-article.component'),
  },
  {
    path: 'accept-invite/:token',
    title: 'Uitnodiging accepteren – Reservatie App',
    loadComponent: () => import('./accept-invite/accept-invite.component'),
  },
  {
    path: 'error',
    title: 'Fout – Reservatie App',
    loadComponent: () => import('./error-page/error-page.component'),
  },
  {
    path: 'select-tenant',
    title: 'Kies organisatie – Reservatie App',
    loadComponent: () => import('./select-tenant/select-tenant.component'),
  },
  // Catch /user/login — Auth0 or bots may navigate here; redirect to login flow
  {
    path: 'user/login',
    loadComponent: () => import('./login-redirect/login-redirect.component'),
  },
  // Path-based routing: reservatie.app/:slug/...
  // Must come after all named top-level paths so they take precedence.
  {
    path: ':slug',
    canActivate: [SlugTenantGuard],
    children: [
      {
        path: 'production',
        title: AppTitleService,
        loadComponent: () => import('./production/production.component'),
        data: { depthX: 0 },
      },
      {
        path: 'production/:id',
        title: AppTitleService,
        loadComponent: () => import('./production/production.component'),
        data: { depthX: 0 },
      },
      {
        path: 'reservation/:reservationId',
        title: AppTitleService,
        loadComponent: () => import('./reservation/reservation.component'),
        data: { depthX: 1 },
      },
      {
        path: 'admin',
        title: AppTitleService,
        loadChildren: () => import('./admin/admin.routes'),
        data: { depthX: 1, titlePrefix: 'Administratie' },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'production',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [RootCanActivateService],
    component: AppComponent,
  },
];
